const defaultState = {
    units: [],
    unitsTerm: [],
    unit: {},
    loading: false,
    errors:{}
  }
  
export default (state=defaultState, action={}) => {
    switch (action.type) {
      case 'FETCH_UNITS_FULFILLED': {
        return {
          ...state,
          units: action.payload.data,
          loading: false,
          errors: {}
        }
      }
  
      case 'FETCH_UNITS_PENDING': {
        return {
          ...state,
          loading: true,
          errors: {}
        }
      }
  
      case 'FETCH_UNITS_REJECTED': {
        return {
          ...state,
          loading: false,
          errors: { global: action.payload.message }
        }
      }
      
      //Unidades Térmicas
      case 'FETCH_UNITS_TERM_FULFILLED': {
        return {
          ...state,
          unitsTerm: action.payload.data,
          loading: false,
          errors: {}
        }
      }
  
      case 'FETCH_UNITS_TERM_PENDING': {
        return {
          ...state,
          loading: true,
          errors: {}
        }
      }
  
      case 'FETCH_UNITS_TERM_REJECTED': {
        return {
          ...state,
          loading: false,
          errors: { global: action.payload.message }
        }
      }
  
      case 'NEW_UNIT': {
        return {
          ...state,
          unit: {}
        }
      }
  
      case 'SAVE_UNIT_PENDING': {
        return {
          ...state,
          loading: true
        }
      }
  
      case 'SAVE_UNIT_FULFILLED': {
        return {
          ...state,
          units: [...state.units, action.payload.data],
          errors: {},
          loading: false
        }
      }
  
      case 'SAVE_UNIT_REJECTED': {
        const data = action.payload.response.data;
        // convert feathers error formatting to match client-side error formatting
        const { COD_SIME, COD_UF, COD_AB,FLAG_G,FLAG_GT,FLAG_B,FLAG_BT,FLAG_C,FLAG_CB,FLAG_GG,FLAG_BG,START_DELAY,START_DELAY_B,NUM_GROUPS,MAX_POW,MIN_TEC,MAX_POW_B,MIN_TEC_B,FINISH_DELAY,FINISH_DELAY_B, COUNTRY_CODE, TECHNOLOGY } = data.errors;
        const errors = { global: data.message, COD_SIME, COD_UF, COD_AB,FLAG_G,FLAG_GT,FLAG_B,FLAG_BT,FLAG_C,FLAG_CB,FLAG_GG,FLAG_BG,START_DELAY,START_DELAY_B,NUM_GROUPS,MAX_POW,MIN_TEC,MAX_POW_B,MIN_TEC_B,FINISH_DELAY,FINISH_DELAY_B, COUNTRY_CODE, TECHNOLOGY  };
        return {
          ...state,
          errors: errors,
          loading: false
        }
      }
  
      case 'FETCH_UNIT_PENDING': {
        return {
          ...state,
          loading: true,
          unit: {}
        }
      }
  
      case 'FETCH_UNIT_FULFILLED': {
        return {
          ...state,
          unit: action.payload.data[0],
          errors: {},
          loading: false
        }
      }
  
      case 'UPDATE_UNIT_PENDING': {
        return {
          ...state,
          loading: true
        }
      }
  
      case 'UPDATE_UNIT_FULFILLED': {
        const unit = action.payload.data;
        return {
          ...state,
          units: state.units.map(item => item.ID === unit.ID ? unit : item),
          errors: {},
          loading: false
        }
      }
  
      case 'UPDATE_UNIT_REJECTED': {
        const data = action.payload.response.data;
        const { COD_SIME, COD_UF, COD_AB,FLAG_G,FLAG_GT,FLAG_B,FLAG_BT,FLAG_C,FLAG_CB,FLAG_GG,FLAG_BG,START_DELAY,START_DELAY_B,NUM_GROUPS,MAX_POW,MIN_TEC,MAX_POW_B,MIN_TEC_B,FINISH_DELAY,FINISH_DELAY_B, COUNTRY_CODE, TECHNOLOGY } = data.errors;
        const errors = { global: data.message, COD_SIME, COD_UF, COD_AB,FLAG_G,FLAG_GT,FLAG_B,FLAG_BT,FLAG_C,FLAG_CB,FLAG_GG,FLAG_BG,START_DELAY,START_DELAY_B,NUM_GROUPS,MAX_POW,MIN_TEC,MAX_POW_B,MIN_TEC_B,FINISH_DELAY,FINISH_DELAY_B, COUNTRY_CODE, TECHNOLOGY };
        return {
          ...state,
          errors: errors,
          loading: false
        }
      }
  
      case 'DELETE_UNIT_FULFILLED': {
        const id = parseInt(action.payload.data.ID, 10);
        return {
          ...state,
          units: state.units.filter(item => item.ID !== id)
        }
      }
  
      default:
        return state;
    }
  }



// WEBPACK FOOTER //
// ./src/reducers/unit-reducer.js